import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

function UploadDocumentModal(props) {
  const { uploadDocument, type, competitionId, confirmBtnText, ...rest } =
    props;
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm({
      displayName: '',
    });
    setErrors({});
  }, [props.show]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const findFormErrors = () => {
    const { file, displayName } = form;
    const newErrors = {};
    // file errors
    if (!file) {
      newErrors.file = 'Du måste välja en fil.';
    } else if (file.type !== 'application/pdf') {
      newErrors.file = 'Endast tillåtet filformat PDF.';
    } else if (file.size > 2048000) {
      newErrors.file = 'Filen är för stor. Maximal filstorlek 2 MB.';
    }
    // displayName errors
    if (!displayName || displayName === '') {
      newErrors.displayName = 'Du måste ange ett visningsnamn.';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const formData = new FormData(e.target);
      uploadDocument(formData);
    }
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ladda upp dokument</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} id='upload-document-form'>
          <p>Giltigt filformat PDF. Maximal filstorlek 2 MB.</p>
          <Form.Group className='mt-2'>
            <Form.Control
              type='file'
              name='file'
              multiple={false}
              accept='application/pdf'
              onChange={(e) => setField('file', e.target.files[0])}
              isInvalid={!!errors.file}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.file}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Visningsnamn</Form.Label>
            <Form.Control
              type='text'
              name='displayName'
              value={form.displayName}
              placeholder='Ange namn som visas i appen'
              onChange={(e) => setField('displayName', e.target.value)}
              isInvalid={!!errors.displayName}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.displayName}
            </Form.Control.Feedback>
          </Form.Group>
          <input type='hidden' value={competitionId} name='competitionId' />
          <input type='hidden' value={type} name='type' />
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='upload-document-form'>
          {confirmBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UploadDocumentModal;
